export const countries = require('country-list')

countries.overwrite([
  { code: 'KP', name: 'Korea, North' },
  { code: 'KR', name: 'Korea, South' },
  { code: 'LA', name: 'Laos' },
  { code: 'TW', name: 'Taiwan' }
])

export function getSortedCountries () {
  const countryList = countries.getData()
  countryList.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
  return countryList
}
